import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reportFill" }

import { basicFormConfig } from './config/form.config'
import { useRoute } from 'vue-router'
import { ref } from 'vue'
import BasicForm from '@/components/BasicForm.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const route = useRoute()
const defaultInfo = ref({})
defaultInfo.value = route.query
const dialogVisible = ref(false)
const basicFormRef = ref<InstanceType<typeof BasicForm>>()
const tableConfig = ref([{}])
const onAddItem = () => {
  otherInfo.value.custCommPlanStocks.push({})
  tableConfig.value.push({
    stockCode: '',
    shares: '',
    buyinTime: '',
    cost: ''
  })
}
const deleteRow = (index: number) => {
  debugger
  if (otherInfo.value.custCommPlanStocks[index].id != null) {
    otherInfo.value.delStocks.push(otherInfo.value.custCommPlanStocks[index].id)
  }
  tableConfig.value.splice(index, 1)
  otherInfo.value.custCommPlanStocks.splice(index, 1)
}
const otherInfo = ref({ custCommPlanStocks: [{}], delStocks: [] })
debugger
otherInfo.value.custCommPlanStocks = JSON.parse(
  defaultInfo.value.custCommPlanStocks
)
tableConfig.value = JSON.parse(defaultInfo.value.custCommPlanStocks)

const closePage = () => {
  window.close()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BasicForm, {
      basicFormConfig: _unref(basicFormConfig),
      pageName: "custCommPlan",
      ref_key: "basicFormRef",
      ref: basicFormRef,
      defaultInfo: defaultInfo.value,
      otherInfo: otherInfo.value,
      onClosePage: closePage
    }, {
      bottom: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          icon: "el-icon-plus",
          size: "mini",
          style: {"width":"6%","margin-bottom":"0.1%"},
          onClick: onAddItem
        }, {
          default: _withCtx(() => [
            _createTextVNode("添加")
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: tableConfig.value,
              height: "250",
              stripe: "true",
              border: "true",
              style: {"width":"50%","margin-left":"3%","margin-bottom":"1%"},
              "header-cell-style": { background: '#eef1f6', color: '#606266' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "股票代码",
                  align: "center",
                  prop: "stockCode"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: 
                      otherInfo.value.custCommPlanStocks[scope.$index].stockCode
                    ,
                          "onUpdate:modelValue": ($event: any) => ((
                      otherInfo.value.custCommPlanStocks[scope.$index].stockCode
                    ) = $event),
                          maxlength: "6"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "股数（股）",
                  align: "center",
                  prop: "shares"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "number",
                          modelValue: otherInfo.value.custCommPlanStocks[scope.$index].shares,
                          "onUpdate:modelValue": ($event: any) => ((otherInfo.value.custCommPlanStocks[scope.$index].shares) = $event),
                          maxlength: "9"
                        }, {
                          suffix: _withCtx(() => [
                            _createTextVNode("股")
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "买进时间",
                  align: "center",
                  prop: "buyinTime"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          style: {"width":"100%"},
                          "value-format": "YYYY-MM-DD hh:mm:ss",
                          modelValue: 
                      otherInfo.value.custCommPlanStocks[scope.$index].buyinTime
                    ,
                          "onUpdate:modelValue": ($event: any) => ((
                      otherInfo.value.custCommPlanStocks[scope.$index].buyinTime
                    ) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "成本",
                  align: "center",
                  prop: "cost"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "number",
                          modelValue: otherInfo.value.custCommPlanStocks[scope.$index].cost,
                          "onUpdate:modelValue": ($event: any) => ((otherInfo.value.custCommPlanStocks[scope.$index].cost) = $event),
                          maxlength: "9"
                        }, {
                          suffix: _withCtx(() => [
                            _createTextVNode("元")
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  align: "center",
                  width: "100"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      link: "",
                      type: "primary",
                      size: "mini",
                      onClick: _withModifiers(($event: any) => (deleteRow(scope.$index)), ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 删除 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["basicFormConfig", "defaultInfo", "otherInfo"])
  ]))
}
}

})